export enum RoleName {
  admin = "admin",
  user = "user",
}

export interface RoleModel {
  id: number;
  name: RoleName;
}
